
import * as THREE from "../../libs/three.js/build/three.module.js";
import {LineMaterial} from "../../libs/three.js/lines/LineMaterial.js";
import {GeoPackageLoader, Geopackage} from "./GeoPackageLoader.js";

export class GeoJSONLoader {
    static async loadBuffer(buffer, params) {
        params = params || {};
        let transform = params.transform;
        if (!transform) transform = {forward: (arg) => arg};

        const text = new TextDecoder().decode(buffer);
        const geojson = JSON.parse(text);

        const geopackageNode = new THREE.Object3D();
        geopackageNode.name = params.source || 'GeoJSON';
        geopackageNode.potree = { source: params.source };

        const geo = new Geopackage();
        geo.path = params.source;
        geo.node = geopackageNode;
        const zOffset = params.zOffset ?? 0;
        geo.zOffset = zOffset;
        geopackageNode.position.z = zOffset;

        const matLine = new LineMaterial({
            color: params.color != null ? new THREE.Color(params.color) : new THREE.Color(0.9, 0.6, 0.1),
            linewidth: 2,
            resolution: new THREE.Vector2(1000, 1000),
            dashed: false
        });

        const node = new THREE.Object3D();
        node.name = 'features';
        geo.node.add(node);

        let features = [];
        if (geojson.type === 'FeatureCollection') {
            features = geojson.features || [];
        } else if (geojson.type === 'Feature') {
            features = [geojson];
        }

        // Auto-detect if coordinates are already in projected CRS (not WGS84)
        // by checking if first coordinate values are outside lon/lat range
        let useTransform = transform;
        const firstCoord = GeoJSONLoader._findFirstCoordinate(features);
        if (firstCoord && (Math.abs(firstCoord[0]) > 360 || Math.abs(firstCoord[1]) > 90)) {
            // Coordinates are already in projected CRS, skip transform
            useTransform = { forward: (arg) => arg };
        }

        for (const feature of features) {
            if (!feature.geometry) continue;
            const featureNode = GeoPackageLoader.featureToSceneNode(feature, matLine, null, useTransform);
            if (featureNode) node.add(featureNode);
        }

        return geo;
    }

    static _findFirstCoordinate(features) {
        for (const f of features) {
            if (!f.geometry) continue;
            const coords = f.geometry.coordinates;
            if (!coords) continue;
            if (f.geometry.type === 'Point') return coords;
            if (Array.isArray(coords[0]) && typeof coords[0][0] === 'number') return coords[0];
            if (Array.isArray(coords[0]) && Array.isArray(coords[0][0])) return coords[0][0];
        }
        return null;
    }
}
